import { Box, Typography } from '@mui/material';

import BackButton from './BackButton';

import styles from './styles';

type Props = {
  title: string;
  hasBackButton?: boolean;
};

const Header = ({ title, hasBackButton }: Props): JSX.Element => (
  <Box sx={styles.root}>
    {hasBackButton && (
      <Box sx={styles.backSlot}>
        <BackButton />
      </Box>
    )}
    <Typography
      sx={styles.title}
      variant="h6"
      component="h1"
      color="text.primary"
    >
      {title}
    </Typography>
  </Box>
);

export default Header;
